import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TranslationExtenderService } from '../services/translation-extender.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs'; // used for translationExtender.load()

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const translationExtender = inject(TranslationExtenderService);
  const translate = inject(TranslateService);

  if (!authService.isAuthenticated()) {
    router.navigate(['/'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // Reuse the bootstrap CSRF promise started in app.ts — no duplicate HTTP request.
  await authService.ensureCsrfReady();

  // Ensure all post-login translation modules are available before the route renders.
  const lang = translate.currentLang || localStorage.getItem('lang') || 'en';
  await firstValueFrom(translationExtender.load(lang));

  return true;
};
